import React, { FC } from "react";

export const DividableLabel: FC<{ texts: string[] }> = ({ texts }) => (
  <>
    {texts.map((text, index) => (
      <span key={index} style={{ display: "inline-block" }}>{text}</span>
    ))}
  </>
);
